import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enMessages from '../messages/en.json';
import esMessages from '../messages/es.json';

const isBrowser = typeof window !== 'undefined';

// Initialize i18next
if (isBrowser) {
  i18n.use(LanguageDetector);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enMessages },
      es: { translation: esMessages },
    },
    // Keep client-only sections aligned with the server default when no cookie is present.
    lng: !isBrowser ? 'es' : undefined,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['cookie', 'localStorage'],
      caches: ['cookie'],
      lookupCookie: 'NEXT_LOCALE',
    }
  });

export default i18n;
